import PremiumContentSlider from './PremiumContentSlider';
import PremiumContentSliderContainer from './PremiumContentSlider.container';

export default PremiumContentSliderContainer(PremiumContentSlider);
